import api from 'api/axios-instance';
import { AxiosResponse } from 'axios';

export abstract class BaseService {
    protected abstract get resourceName(): string;

    protected get<TResponse>(relativeUrl: string, params?: object): Promise<AxiosResponse<TResponse>> {
        return api.get<TResponse>(this.buildUrl(relativeUrl), { params });
    }

    protected post<TRequest, TResponse>(
        body: TRequest,
        relativeUrl: string = ''
    ): Promise<AxiosResponse<TResponse>> {
        return api.post<TResponse>(this.buildUrl(relativeUrl), body);
    }

    protected put<TRequest, TResponse>(
        relativeUrl: string,
        body: TRequest
    ): Promise<AxiosResponse<TResponse>> {
        return api.put<TResponse>(this.buildUrl(relativeUrl), body);
    }

    protected patch<TRequest, TResponse>(
        relativeUrl: string,
        body: TRequest
    ): Promise<AxiosResponse<TResponse>> {
        return api.patch<TResponse>(this.buildUrl(relativeUrl), body);
    }

    protected delete(relativeUrl: string): Promise<AxiosResponse<void>> {
        return api.delete<void>(this.buildUrl(relativeUrl));
    }

    protected deleteByIds<TRequest>(relativeUrl: string, body: TRequest): Promise<AxiosResponse<void>> {
        return api.delete<void>(this.buildUrl(relativeUrl), { data: body });
    }

    protected getFile(relativeUrl: string): Promise<AxiosResponse<Blob>> {
        return api.get<Blob>(this.buildUrl(relativeUrl), { responseType: 'blob' });
    }

    protected postFile<TRequest>(
        body: TRequest,
        relativeUrl: string = ''
    ): Promise<AxiosResponse<Blob>> {
        return api.post<Blob>(this.buildUrl(relativeUrl), body, { responseType: 'blob' });
    }

    protected forgotPassword<TResponse>(email: string): Promise<AxiosResponse<TResponse>> {
        return api.patch<TResponse>('users/forgot-password', email);
    }

    protected buildUrl(relativeUrl: string = ''): string {
        const resource = this.resourceName.replace(/^\/|\/$/g, '');
        const path = relativeUrl.replace(/^\/|\/$/g, '');

        return [resource, path].filter(Boolean).join('/');
    }
}
